import styled from 'styled-components';
import { HOMEPAGE_MAIN_TITLE_COLOR, HOMEPAGE_TEXT_COLOR } from '../../utils/colors';
import { sansSerifFont } from '../layout/layout.styles';

export const Title = styled.h1`
  color: ${HOMEPAGE_MAIN_TITLE_COLOR};
  font-size: 36px;
  font-weight: 300;
  line-height: 1.11em;
  letter-spacing: -0.18px;
`;

export const PartnersContainer = styled.div`
  margin: 41px;
  text-align: center;

  ${Title} {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33em;
    letter-spacing: 0.6px;
    color: ${HOMEPAGE_TEXT_COLOR};
  }
`;

export const PartnersListContainer = styled.div`
  --columns-number: 2;
  --columns-size: 120px;
  display: grid;
  justify-content: center;
  grid-auto-rows: calc(var(--columns-size) / 2);
  grid-template-columns: repeat(var(--columns-number), var(--columns-size));
  grid-gap: 60px;
`;

export const PartnerItem = styled.a`
  display: flex;
  align-content: center;
  justify-content: center;
  color: ${HOMEPAGE_TEXT_COLOR};
  text-transform: uppercase;
  font-size: 0.55em;
  overflow: hidden;
  ${sansSerifFont}
`;
